import { useQuery } from '@tanstack/react-query'
import { axiosInstance } from '@/lib/axios'
import { QUERY_KEY_SETTINGS_TIMESHEET_SETTLEMENT_CYCLE, SETTINGS_QUERY_ALWAYS_REVALIDATE } from '@/lib/api/constants'
import { TimesheetSettlementType } from '@/app/constants/configuration/timesheetSettlementType'

export interface CurrentSettlementCycleModel {
  currentSettlementType: TimesheetSettlementType
  periodLengthInMonths: number
}


export function useQueryCurrentSettlementCycle(companyId: string) {
  return useQuery<CurrentSettlementCycleModel>({
    queryKey: [QUERY_KEY_SETTINGS_TIMESHEET_SETTLEMENT_CYCLE, companyId],
    queryFn: async () => {
      const { data } = await axiosInstance.get<CurrentSettlementCycleModel>(
        `/api/${companyId}/configuration/timesheet/currentSettlementCycle`,
      )
      return data
    },
    enabled: !!companyId,
    ...SETTINGS_QUERY_ALWAYS_REVALIDATE,
  })
}
